<template>
  <header :class="$style.container">
    <button :class="$style.toggle" type="button" @click="toggleMenu">
      <base-icon
        :class="[$style.arrowIcon, { [$style.showMenu]: showMenu }]"
        name="arrow-back"
        themeSize="x-large"
        themeColor="light"
      />
      <base-icon
        :class="[$style.menuIcon, { [$style.showMenu]: showMenu }]"
        name="menu"
        themeSize="x-large"
        themeColor="light"
      />
    </button>

    <h1 :class="$style.title">BloqCloud Console</h1>
    <span :class="$style.impersonated" v-if="impersonator"
      >Impersonator {{ impersonator.email }}</span
    >

    <div :class="$style.menuWrapper">
      <button
        :class="$style.menuToggle"
        @click="toggleSessionMenu"
        type="button"
      >
        <span :class="$style.email">{{ profile.email }}</span>
        <base-icon name="account" themeSize="x-large" themeColor="light" />
        <base-icon name="arrow-down" themeSize="large" themeColor="light" />
      </button>
      <div
        :class="$style.dropdown"
        v-if="showSessionMenu"
        v-on-clickaway="closePanel"
      >
        <div :class="$style.dropdownEmail">{{ profile.email }}</div>
        <router-link :class="$style.dropdownItem" :to="{ name: 'profile' }"
          >Account Info</router-link
        >
        <button :class="$style.dropdownItem" type="button" @click="logout">
          Log out
        </button>
      </div>
    </div>
  </header>
</template>

<script>
import auth from '@/services/auth'
import { mixin as clickaway } from 'vue-clickaway'
import { mapState, mapMutations } from 'vuex'

export default {
  mixins: [clickaway],

  props: {
    title: { String }
  },

  data: () => ({
    impersonator: auth.impersonator()
  }),

  computed: {
    ...mapState(['profile', 'showMenu', 'showSessionMenu'])
  },

  watch: {
    '$route.name'() {
      this.toggleSessionMenu(false)
    }
  },

  methods: {
    ...mapMutations(['toggleMenu', 'toggleSessionMenu']),

    closePanel() {
      this.toggleSessionMenu(false)
    },

    logout() {
      this.toggleSessionMenu(false)
      auth.logout()
      this.$router.push({ name: 'login' })
    }
  }
}
</script>

<style lang="scss" module>
.container {
  background: $color-primary;
  color: $color-light;
  height: $topbar-height;
  padding-left: spacing(2);
  padding-right: spacing(2);
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 2px 1px -1px rgba(0, 0, 0, 0.12),
    0 1px 1px 0 rgba(0, 0, 0, 0.14), inset 0 1px 0 0 rgba(255, 255, 255, 0.25);

  @include wider-than(790px) {
    padding-left: spacing(4);
    padding-right: spacing(6);
  }
}

.toggle {
  @include reset-btn;

  @include wider-than(1000px) {
    display: none;
  }
}

.title {
  @include ellipsis;
  margin: 0;
  margin-left: spacing(2);
  flex-grow: 1;
  font-size: $size-large;
  line-height: $size-xx-large;
  font-weight: $weight-semibold;

  @include wider-than(1000px) {
    font-size: $size-x-large;
    margin-left: 0;
  }
}

.menuWrapper {
  position: relative;
}

.menuToggle {
  @include reset-btn;
  display: flex;
  align-items: center;
  border-radius: $radius-medium;
  padding: spacing(0.5) spacing(0.5) spacing(0.5) spacing(1);

  &:focus,
  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }
}

.arrowIcon {
  display: inline-block !important;
  @include wider-than(1000px) {
    display: none !important;
  }
  &.showMenu {
    display: none !important;
    @include wider-than(1000px) {
      display: inline-block !important;
    }
  }
}

.menuIcon {
  display: none !important;
  @include wider-than(1000px) {
    display: inline-block !important;
  }
  &.showMenu {
    display: inline-block !important;
    @include wider-than(1000px) {
      display: none !important;
    }
  }
}

.email {
  color: $color-light;
  font-size: $size-medium;
  font-weight: $weight-regular;
  line-height: 1.5;
  margin-right: spacing(2);
  display: none;

  @include wider-than(700px) {
    display: block;
  }
}

.dropdown {
  position: absolute;
  right: 0;
  width: 100%;
  min-width: 180px;
  background: $color-light;
  border-radius: $radius-medium;
  box-shadow: $shadow-medium;
  z-index: 1;
  padding: spacing(1) 0;
}

.dropdownEmail {
  font-size: $size-x-small;
  font-weight: $weight-medium;
  padding: spacing(1);
  color: $color-primary-light;
  display: block;

  @include wider-than(700px) {
    display: none;
  }
}

.dropdownItem {
  @include reset-btn;
  padding: spacing(1);
  display: block;
  width: 100%;
  text-align: left;
  font-size: $size-x-small;
  font-weight: $weight-medium;
  text-decoration: none;
  color: $color-copy;

  &:hover,
  &:focus {
    color: $color-primary-light;
  }
}

.impersonated {
  font-size: 13px;
  font-weight: bold;
}
</style>
